/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { ContentType, HttpClient, RequestParams } from "../http-client";
import { Query2 as QueryModel, QuerySumInfoData } from "../models";

export class Query2<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  /**
   * No description
   *
   * @tags query2
   * @name QuerySumInfo
   * @summary Query combined sum info
   * @request POST:/query2
   * @secure
   */
  querySumInfo = (data: QueryModel, params: RequestParams = {}) =>
    this.http.request<QuerySumInfoData, void>({
      path: `/query2`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
}
